/* eslint-disable comma-dangle no-tabs */
/* eslint-disable */
// Please learn from https://docx.js.org/ & https://docxjs-editor.vercel.app/playground/
// before reading this code.
import moment from 'moment';
import ContentWordGeneratorInc from './ContentWordGenerator'
import {
  // AlignmentType,
  Document,
  // HeadingLevel,
  Packer,
  Paragraph,
  // TabStopPosition,
  // TabStopType,
  Table,
  TableRow,
  TableCell,
  TextRun,
  WidthType
} from 'docx';
import { saveAs } from 'file-saver';
/**
 * @returns {docx.Document}
 * @see https://docx.js.org/
 */
export const generateDocument = (creatorConceptData) => {
  // Your code goes here
  // Define the table structure
  const spaceHund = new Paragraph({
    children: [
      new TextRun({
        text: ``
      })
    ],
    spacing: {
      after: 0, // Space after the paragraph (10px = 200 half-points)
    },
  });

  const pageTitle = new Paragraph({
    alignment: 'center',
    spacing: {
      after: 200, // Space after the paragraph (10px = 200 half-points)
    },
    children: [
      new TextRun({
        text: "Content Storyboard Flow",
        font: "Calibri", // Same global font
        size: 30, // Size in half-points (15px = 30 half-points)
        bold: true,
      }),
    ],
  });

  const campaignName = new Paragraph({
    children: [
      new TextRun({
        text: `Campaign Name: `,
        bold: true, // Bold for the label
        size: 25, // Size in half-points (16px = 32 half-points)
        font: "Calibri", // Same global font
      }),
      new TextRun({
        text: creatorConceptData.campaignName,
        bold: true, // Bold for the label
        size: 25, // Size in half-points (16px = 32 half-points)
        font: "Calibri", // Same global font
      }),
    ],
    spacing: {
      after: 100, // Space after the paragraph (10px = 200 half-points)
    },
  });
  
  const handle = new Paragraph({
    children: [
      new TextRun({
        text: `Creator Handle: `,
        bold: true, // Bold for the label
        size: 25, // Size in half-points (16px = 32 half-points)
        font: "Calibri", // Same global font
      }),
      new TextRun({
        text: creatorConceptData.creatorHandle,
        bold: true, // Bold for the label
        size: 25, // Size in half-points (16px = 32 half-points)
        font: "Calibri", // Same global font
      }),
    ],
    spacing: {
      after: 100, // Space after the paragraph (10px = 200 half-points)
    },
  });

  const submissionDate = new Paragraph({
    children: [
      new TextRun({
        text: `Draft Submission Date: `,
        bold: true, // Bold for the label
        size: 25, // Size in half-points (16px = 32 half-points)
        font: "Calibri", // Same global font
      }),
      new TextRun({
        text: creatorConceptData.submissionDate,
        bold: true, // Bold for the label
        size: 25, // Size in half-points (16px = 32 half-points)
        font: "Calibri", // Same global font
      }),
    ],
    spacing: {
      after: 200, // Space after the paragraph (10px = 200 half-points)
    },
  });
  const deliDetails = new Paragraph({
    children: [
      new TextRun({
        text: `Deliverable Details: `,
        bold: true, // Bold for the label
        size: 25, // Size in half-points (16px = 32 half-points)
        font: "Calibri", // Same global font
      }),
      new TextRun({
        text: creatorConceptData.submissionDate,
        bold: true, // Bold for the label
        size: 25, // Size in half-points (16px = 32 half-points)
        font: "Calibri", // Same global font
      }),
    ],
    spacing: {
      after: 200, // Space after the paragraph (10px = 200 half-points)
    },
  });
  let children = [
    pageTitle,
    campaignName,
    handle,
    submissionDate,
    deliDetails
  ]
  for (let deliItem of creatorConceptData.deliverables) {
    // Create a table to simulate the background color
    const concept = new Paragraph({
        children: [
          new TextRun({
            text: `Concept: `,
            bold: true, // Bold for the label
            size: 25, // Size in half-points (16px = 32 half-points)
            font: "Calibri", // Same global font
          }),
          new TextRun({
            text: deliItem.concept || '-',
            bold: true, // Bold for the label
            size: 25, // Size in half-points (16px = 32 half-points)
            font: "Calibri", // Same global font
          }),
        ],
        spacing: {
          after: 100, // Space after the paragraph (10px = 200 half-points)
        },
      })
      const reasonConcept = new Paragraph({
        children: [
          new TextRun({
            text: `Reason for concept: `,
            bold: true, // Bold for the label
            size: 25, // Size in half-points (16px = 32 half-points)
            font: "Calibri", // Same global font
          }),
          new TextRun({
            text: deliItem.reasonConcept || '-',
            bold: true, // Bold for the label
            size: 25, // Size in half-points (16px = 32 half-points)
            font: "Calibri", // Same global font
          }),
        ],
        spacing: {
          after: 100, // Space after the paragraph (10px = 200 half-points)
        },
      })
      const musicChoice = new Paragraph({
        children: [
          new TextRun({
            text: `Music choice: `,
            bold: true, // Bold for the label
            size: 25, // Size in half-points (16px = 32 half-points)
            font: "Calibri", // Same global font
          }),
          new TextRun({
            text: deliItem.musicChoice || '-',
            bold: true, // Bold for the label
            size: 25, // Size in half-points (16px = 32 half-points)
            font: "Calibri", // Same global font
          }),
        ],
        spacing: {
          after: 100, // Space after the paragraph (10px = 200 half-points)
        },
      })
      children.push(concept)
      children.push(reasonConcept)
      children.push(musicChoice)
      
    let deliTableTitle = new Table({
      rows: [
        new TableRow({
          children: [
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: deliItem.title,
                      bold: true, // Bold text
                      size: 27, // Size in half-points (24px = 48 half-points)
                      font: "Calibri", // Same global font
                    }),
                  ],
                  spacing: {
                    before: 100,
                    after: 100,
                  },
                  indent: {
                    left: 100, // Indent left (12px)
                    top: 240, // Indent right (12px)
                  },
                  alignment: 'left', // Center the text within the cell
                }),
              ],
              shading: {
                fill: 'F4F4F4', // Light gray background color
              },
              width: {
                size: 10000, // Width of the cell
                type: WidthType.DXA,
              },
              borders: {
                top: { style: undefined },
                bottom: { style: undefined },
                left: { style: undefined },
                right: { style: undefined },
              },
            }),
          ],
          width: {
            size: 10000, // Width of the cell
            type: WidthType.DXA,
          }
        }),
      ]
    });
    children.push(deliTableTitle)
    children.push(spaceHund)
    if (deliItem.type !== 'igCarousel' && deliItem.type !== 'linkedIn') {
      // if (deliItem.type === 'igReel') {
      //   const concept = new Paragraph({
      //     children: [
      //       new TextRun({
      //         text: `Concept: `,
      //         bold: true, // Bold for the label
      //         size: 25, // Size in half-points (16px = 32 half-points)
      //         font: "Calibri", // Same global font
      //       }),
      //       new TextRun({
      //         text: deliItem.concept || '-',
      //         bold: true, // Bold for the label
      //         size: 25, // Size in half-points (16px = 32 half-points)
      //         font: "Calibri", // Same global font
      //       }),
      //     ],
      //     spacing: {
      //       after: 100, // Space after the paragraph (10px = 200 half-points)
      //     },
      //   })
      //   const reasonConcept = new Paragraph({
      //     children: [
      //       new TextRun({
      //         text: `Reason for concept: `,
      //         bold: true, // Bold for the label
      //         size: 25, // Size in half-points (16px = 32 half-points)
      //         font: "Calibri", // Same global font
      //       }),
      //       new TextRun({
      //         text: deliItem.reasonConcept || '-',
      //         bold: true, // Bold for the label
      //         size: 25, // Size in half-points (16px = 32 half-points)
      //         font: "Calibri", // Same global font
      //       }),
      //     ],
      //     spacing: {
      //       after: 100, // Space after the paragraph (10px = 200 half-points)
      //     },
      //   })
      //   const musicChoice = new Paragraph({
      //     children: [
      //       new TextRun({
      //         text: `Music choice: `,
      //         bold: true, // Bold for the label
      //         size: 25, // Size in half-points (16px = 32 half-points)
      //         font: "Calibri", // Same global font
      //       }),
      //       new TextRun({
      //         text: deliItem.musicChoice || '-',
      //         bold: true, // Bold for the label
      //         size: 25, // Size in half-points (16px = 32 half-points)
      //         font: "Calibri", // Same global font
      //       }),
      //     ],
      //     spacing: {
      //       after: 100, // Space after the paragraph (10px = 200 half-points)
      //     },
      //   })
      //   children.push(concept)
      //   children.push(reasonConcept)
      //   children.push(musicChoice)
      // }
      for (let boxItem of deliItem.boxes) {
          let imageLinks = []
          for (let imgItem of boxItem.images) {
            if (imgItem.refLinkType === 'link') {
              imageLinks.push(new TextRun({
                text: imgItem.link,
                size: 20, // Size in half-points (24px = 48 half-points)
                font: "Calibri",
              }))
            } else {
              imageLinks.push(new TextRun({
                text: imgItem.imgUrl,
                size: 20, // Size in half-points (24px = 48 half-points)
                font: "Calibri",
              }))
            }
          }
          let sceneInfoTxts = ContentWordGeneratorInc.getTextBlocks(boxItem.scenesInfo)
          let scenceInfoTextRun = sceneInfoTxts.map(part => {
            if (part.startsWith("<span")) {
              // Create a TextRun for the span with background color
              return new TextRun({
                text: part.replace(/<.*?>/g, ''), // Remove HTML tags
                color: "FFFF00", // Background color (yellow)
                bold: false, // Adjust styling as needed
                font: "Calibri", // Same global font
              });
            } else if (part.startsWith("<p>")) {
              // Start a new paragraph if <p> tag is found
              // This is handled by creating a new Paragraph in the loop
            } else if (part.startsWith("</p>")) {
              // End the current paragraph
              return new TextRun('')
            } else {
              // Create a TextRun for normal text
              return new TextRun({
                text: part,
                bold: false, // Adjust styling as needed
                font: "Calibri", // Same global font
              });
            }
          })
          let briefTxts = ContentWordGeneratorInc.getTextBlocks(boxItem.briefText)
          let briefTextRun = briefTxts.map(part => {
            // return new TextRun({
            //   text: txt,
            //   size: 20, // Size in half-points (24px = 48 half-points)
            //   font: "Calibri", // Same global font
            // })
            if (part.startsWith("<span")) {
              // Create a TextRun for the span with background color
              return new TextRun({
                text: part.replace(/<.*?>/g, ''), // Remove HTML tags
                color: "FFFF00", // Background color (yellow)
                bold: false, // Adjust styling as needed
                font: "Calibri", // Same global font
              });
            } else if (part.startsWith("<p>")) {
              // Start a new paragraph if <p> tag is found
              // This is handled by creating a new Paragraph in the loop
            } else if (part.startsWith("</p>")) {
              // End the current paragraph
              return new TextRun('')
            } else {
              // Create a TextRun for normal text
              return new TextRun({
                text: part,
                bold: false, // Adjust styling as needed
                font: "Calibri", // Same global font
              });
            }
          })
          let bodyInfoTxts = ContentWordGeneratorInc.getTextBlocks(boxItem.bodyInfo)
          let bodyInfoPara = [
            new Paragraph({
              children: [
                new TextRun({
                  text: 'BODY',
                  bold: true,
                  size: 22, // Size in half-points (24px = 48 half-points)
                  font: "Calibri", // Same global font
                }),
              ],
              spacing: {
                before: 50,
                after: 100,
              },
              indent: {
                left: 50, // Indent left (12px)
                right: 50, // Indent left (12px)
              },
              alignment: 'left', // Center the text within the cell
            }),
          ]
          bodyInfoTxts.map(part => {
            if (part.startsWith("<span")) {
                // Create a TextRun for the span with background color
                let bodyInfoParaLength = bodyInfoPara.length
                bodyInfoPara[bodyInfoParaLength - 1].root.push(new TextRun({
                  text: part.replace(/<.*?>/g, ''), // Remove HTML tags
                  color: "FFFF00", // Background color (yellow)
                  bold: false, // Adjust styling as needed
                  font: "Calibri", // Same global font
                }))
                // bodyInfoPara.push(
                  
                // )
                // bodyInfoPara.push(
                //   new Paragraph({
                //     children: [
                //       new TextRun({
                //         text: part.replace(/<.*?>/g, ''),
                //         size: 20, // Size in half-points (24px = 48 half-points)
                //         font: "Calibri", // Same global font,
                //         color: "FFFF00", // Background color (yellow)
                //       })
                //     ],
                //     spacing: {
                //       before: 50,
                //       after: 100,
                //     },
                //     indent: {
                //       left: 50, // Indent left (12px)
                //       right: 50, // Indent left (12px)
                //     },
                //     alignment: 'left', // Center the text within the cell
                //   })
                // )
            } else if (part.startsWith("<p>")) {
                // Start a new paragraph if <p> tag is found
                // This is handled by creating a new Paragraph in the loop
                bodyInfoPara.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: part.replace(/<.*?>/g, ''),
                        size: 20, // Size in half-points (24px = 48 half-points)
                        font: "Calibri", // Same global font
                      })
                    ],
                    spacing: {
                      before: 50,
                      after: 100,
                    },
                    indent: {
                      left: 50, // Indent left (12px)
                      right: 50, // Indent left (12px)
                    },
                    alignment: 'left', // Center the text within the cell
                  })
                )
            } else if (part.startsWith("</p>")) {
                // End the current paragraph
                bodyInfoPara.push(
                  new Paragraph('')
                )
            } else {
              // Create a TextRun for normal text
              // bodyInfoPara.push(
              //   new TextRun({
              //     text: part,
              //     bold: false, // Adjust styling as needed
              //     font: "Calibri", // Same global font
              //   })
              // )
              bodyInfoPara.push(
                new Paragraph({
                  children: [
                    new TextRun({
                      text: part.replace(/<.*?>/g, ''),
                      size: 20, // Size in half-points (24px = 48 half-points)
                      font: "Calibri", // Same global font
                    })
                  ],
                  spacing: {
                    before: 50,
                    after: 100,
                  },
                  indent: {
                    left: 50, // Indent left (12px)
                    right: 50, // Indent left (12px)
                  },
                  alignment: 'left', // Center the text within the cell
                })
              )
            }
          })
          let briefPointerTxts = ContentWordGeneratorInc.getTextBlocks(boxItem.briefPointer)
          let briefPointerPara = []
          briefPointerTxts.map(part => {
            // briefPointerPara.push(
            //   new Paragraph({
            //     children: [
            //       new TextRun({
            //         text: txt,
            //         size: 20, // Size in half-points (24px = 48 half-points)
            //         font: "Calibri", // Same global font
            //       })
            //     ],
            //     spacing: {
            //       before: 50,
            //       after: 100,
            //     },
            //     indent: {
            //       left: 50, // Indent left (12px)
            //       right: 50, // Indent left (12px)
            //     },
            //     alignment: 'left', // Center the text within the cell
            //   })
            // )
            if (part.startsWith("<span")) {
              // Create a TextRun for the span with background color
              let briefPointerParaLength = briefPointerPara.length
              briefPointerPara[briefPointerParaLength - 1].root.push(new TextRun({
                text: part.replace(/<.*?>/g, ''), // Remove HTML tags
                color: "FFFF00", // Background color (yellow)
                bold: false, // Adjust styling as needed
                font: "Calibri", // Same global font
              }))
              // bodyInfoPara.push(
                
              // )
              // bodyInfoPara.push(
              //   new Paragraph({
              //     children: [
              //       new TextRun({
              //         text: part.replace(/<.*?>/g, ''),
              //         size: 20, // Size in half-points (24px = 48 half-points)
              //         font: "Calibri", // Same global font,
              //         color: "FFFF00", // Background color (yellow)
              //       })
              //     ],
              //     spacing: {
              //       before: 50,
              //       after: 100,
              //     },
              //     indent: {
              //       left: 50, // Indent left (12px)
              //       right: 50, // Indent left (12px)
              //     },
              //     alignment: 'left', // Center the text within the cell
              //   })
              // )
            } else if (part.startsWith("<p>")) {
                // Start a new paragraph if <p> tag is found
                // This is handled by creating a new Paragraph in the loop
                briefPointerPara.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: part.replace(/<.*?>/g, ''),
                        size: 20, // Size in half-points (24px = 48 half-points)
                        font: "Calibri", // Same global font
                      })
                    ],
                    spacing: {
                      before: 50,
                      after: 100,
                    },
                    indent: {
                      left: 50, // Indent left (12px)
                      right: 50, // Indent left (12px)
                    },
                    alignment: 'left', // Center the text within the cell
                  })
                )
            } else if (part.startsWith("</p>")) {
                // End the current paragraph
                briefPointerPara.push(
                  new Paragraph('')
                )
            } else {
              // Create a TextRun for normal text
              // bodyInfoPara.push(
              //   new TextRun({
              //     text: part,
              //     bold: false, // Adjust styling as needed
              //     font: "Calibri", // Same global font
              //   })
              // )
              briefPointerPara.push(
                new Paragraph({
                  children: [
                    new TextRun({
                      text: part.replace(/<.*?>/g, ''),
                      size: 20, // Size in half-points (24px = 48 half-points)
                      font: "Calibri", // Same global font
                    })
                  ],
                  spacing: {
                    before: 50,
                    after: 100,
                  },
                  indent: {
                    left: 50, // Indent left (12px)
                    right: 50, // Indent left (12px)
                  },
                  alignment: 'left', // Center the text within the cell
                })
              )
            }
          })
          let callToActionTxts = ContentWordGeneratorInc.getTextBlocks(boxItem.callToAction)
          let callToActionPara = [new Paragraph({
            children: [
              new TextRun({
                text: 'CTA (input your final CTA scene, not caption)',
                size: 22, // Size in half-points (24px = 48 half-points)
                bold: true, // Adjust styling as needed
                font: "Calibri", // Same global font
              })
            ],
            spacing: { after: 200 }, // Space after the paragraph
          })]
          callToActionTxts.map(part => {
            if (part.startsWith("<span")) {
              // Create a TextRun for the span with background color
              let callToActionParaLength = callToActionPara.length
              callToActionPara[callToActionParaLength - 1].root.push(new TextRun({
                text: part.replace(/<.*?>/g, ''), // Remove HTML tags
                color: "FFFF00", // Background color (yellow)
                bold: false, // Adjust styling as needed
                font: "Calibri", // Same global font
              }))
              // bodyInfoPara.push(
                
              // )
              // bodyInfoPara.push(
              //   new Paragraph({
              //     children: [
              //       new TextRun({
              //         text: part.replace(/<.*?>/g, ''),
              //         size: 20, // Size in half-points (24px = 48 half-points)
              //         font: "Calibri", // Same global font,
              //         color: "FFFF00", // Background color (yellow)
              //       })
              //     ],
              //     spacing: {
              //       before: 50,
              //       after: 100,
              //     },
              //     indent: {
              //       left: 50, // Indent left (12px)
              //       right: 50, // Indent left (12px)
              //     },
              //     alignment: 'left', // Center the text within the cell
              //   })
              // )
            } else if (part.startsWith("<p>")) {
                // Start a new paragraph if <p> tag is found
                // This is handled by creating a new Paragraph in the loop
                callToActionPara.push(
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: part.replace(/<.*?>/g, ''),
                        size: 20, // Size in half-points (24px = 48 half-points)
                        font: "Calibri", // Same global font
                      })
                    ],
                    spacing: {
                      before: 50,
                      after: 100,
                    },
                    indent: {
                      left: 50, // Indent left (12px)
                      right: 50, // Indent left (12px)
                    },
                    alignment: 'left', // Center the text within the cell
                  })
                )
            } else if (part.startsWith("</p>")) {
                // End the current paragraph
                callToActionPara.push(
                  new Paragraph('')
                )
            } else {
              // Create a TextRun for normal text
              // bodyInfoPara.push(
              //   new TextRun({
              //     text: part,
              //     bold: false, // Adjust styling as needed
              //     font: "Calibri", // Same global font
              //   })
              // )
              callToActionPara.push(
                new Paragraph({
                  children: [
                    new TextRun({
                      text: part.replace(/<.*?>/g, ''),
                      size: 20, // Size in half-points (24px = 48 half-points)
                      font: "Calibri", // Same global font
                    })
                  ],
                  spacing: {
                    before: 50,
                    after: 100,
                  },
                  indent: {
                    left: 50, // Indent left (12px)
                    right: 50, // Indent left (12px)
                  },
                  alignment: 'left', // Center the text within the cell
                })
              )
            }
          })
          let table = new Table({
            width: {
              size: '100%', // Set width to 100% of the page
              type: 'pct'
            },
            rows: [
              new TableRow({
                children: [
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: 'Descriptions of scenes/ footage',
                            size: 22, // Size in half-points (24px = 48 half-points)
                            font: "Calibri", // Same global font
                          }),
                        ],
                        spacing: {
                          before: 50,
                          after: 50,
                        },
                        indent: {
                          left: 50, // Indent left (12px)
                          right: 50, // Indent left (12px)
                        },
                        alignment: 'left', // Center the text within the cell
                      })
                    ],
                  }),
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: 'Include text overlays / voiceover script in each scene	',
                            size: 22, // Size in half-points (24px = 48 half-points)
                            font: "Calibri", // Same global font
                          }),
                        ],
                        spacing: {
                          before: 50,
                          after: 50,
                        },
                        indent: {
                          left: 50, // Indent left (12px)
                          right: 50, // Indent left (12px)
                        },
                        alignment: 'left', // Center the text within the cell
                      })
                    ],
                  }),
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: 'Reference links/images',
                            size: 22, // Size in half-points (24px = 48 half-points)
                            font: "Calibri", // Same global font
                          }),
                        ],
                        spacing: {
                          before: 50,
                          after: 50,
                        },
                        indent: {
                          left: 50, // Indent left (12px)
                          right: 50, // Indent left (12px)
                        },
                        alignment: 'left', // Center the text within the cell
                      })
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: [
                          new TextRun({
                            text: 'INTROs: (can be hook/ theme/ title of your video)',
                            bold: true,
                            size: 22, // Size in half-points (24px = 48 half-points)
                            font: "Calibri", // Same global font
                          }),
                        ],
                        spacing: {
                          before: 50,
                          after: 100,
                        },
                        indent: {
                          left: 50, // Indent left (12px)
                          right: 50, // Indent left (12px)
                        },
                        alignment: 'left', // Center the text within the cell
                      }),
                      new Paragraph({
                        children: scenceInfoTextRun,
                        spacing: {
                          before: 50,
                          after: 100,
                        },
                        indent: {
                          left: 50, // Indent left (12px)
                          right: 50, // Indent left (12px)
                        },
                        alignment: 'left', // Center the text within the cell
                      })
                    ],
                  }),
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: briefTextRun,
                        spacing: {
                          before: 50,
                          after: 100,
                        },
                        indent: {
                          left: 50, // Indent left (12px)
                          right: 50, // Indent left (12px)
                        },
                        alignment: 'left', // Center the text within the cell
                      })
                    ],
                  }),
                  new TableCell({
                    children: [
                      new Paragraph({
                        children: imageLinks
                      })
                    ],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    children: bodyInfoPara,
                  }),
                  new TableCell({
                    children: briefPointerPara,
                  }),
                  new TableCell({
                    children: [new Paragraph('')],
                  }),
                ],
              }),
              new TableRow({
                children: [
                  new TableCell({
                    columnSpan: 3,
                    children: callToActionPara,
                  })
                ],
              }),
            ]
          });
          children.push(table)
          children.push(spaceHund)
          children.push(spaceHund)
          children.push(spaceHund)
      }
    }
    if (deliItem.type === 'igCarousel' || deliItem.type === 'linkedIn') {
      for (let boxItem of deliItem.boxes) {      
        let carouselTableRow = [
          new TableRow({
            children: [
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: 'IMAGE',
                        bold: true,
                        size: 22, // Size in half-points (24px = 48 half-points)
                        font: "Calibri",
                      }),
                    ],
                    spacing: {
                      before: 50,
                      after: 50,
                    },
                    indent: {
                      left: 50, // Indent left (12px)
                      right: 50, // Indent left (12px)
                    },
                    alignment: 'left', // Center the text within the cell
                  })
                ],
              }),
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: 'Description of image/gif	',
                        bold: true,
                        size: 22, // Size in half-points (24px = 48 half-points)
                        font: "Calibri",
                      }),
                    ],
                    spacing: {
                      before: 50,
                      after: 50,
                    },
                    indent: {
                      left: 50, // Indent left (12px)
                      right: 50, // Indent left (12px)
                    },
                    alignment: 'left', // Center the text within the cell
                  })
                ],
              }),
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: 'Text on image (if any)	',
                        bold: true,
                        size: 22, // Size in half-points (24px = 48 half-points)
                        font: "Calibri",
                      }),
                    ],
                    spacing: {
                      before: 50,
                      after: 50,
                    },
                    indent: {
                      left: 50, // Indent left (12px)
                      right: 50, // Indent left (12px)
                    },
                    alignment: 'left', // Center the text within the cell
                  })
                ],
              }),
              new TableCell({
                children: [
                  new Paragraph({
                    children: [
                      new TextRun({
                        text: 'Reference links/images',
                        size: 22, // Size in half-points (24px = 48 half-points)
                        font: "Calibri",
                      }),
                    ],
                    spacing: {
                      before: 50,
                      after: 50,
                    },
                    indent: {
                      left: 50, // Indent left (12px)
                      right: 50, // Indent left (12px)
                    },
                    alignment: 'left', // Center the text within the cell
                  })
                ],
              }),
            ],
          })
        ]
        let idx = 0
        for (let imgRow of boxItem.images) {
          let tableRowChild = [
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: idx + 1,
                      bold: true,
                      size: 22, // Size in half-points (24px = 48 half-points)
                      font: "Calibri",
                    }),
                  ],
                  spacing: {
                    before: 50,
                    after: 100,
                  },
                  indent: {
                    left: 50, // Indent left (12px)
                    right: 50, // Indent left (12px)
                  },
                  alignment: 'left', // Center the text within the cell
                })
              ],
            }),
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: imgRow.imgDescription,
                      size: 20, // Size in half-points (24px = 48 half-points)
                      font: "Calibri",
                    }),
                  ],
                  spacing: {
                    before: 50,
                    after: 100,
                  },
                  indent: {
                    left: 50, // Indent left (12px)
                    right: 50, // Indent left (12px)
                  },
                  alignment: 'left', // Center the text within the cell
                })
              ],
            }),
            new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: imgRow.textImage,
                      size: 20, // Size in half-points (24px = 48 half-points)
                      font: "Calibri",
                    }),
                  ],
                  spacing: {
                    before: 50,
                    after: 100,
                  },
                  indent: {
                    left: 50, // Indent left (12px)
                    right: 50, // Indent left (12px)
                  },
                  alignment: 'left', // Center the text within the cell
                })
              ],
            }),
          ]          
          if (imgRow.refLinkType === 'link') {
            let refLinkType = new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: imgRow.link,
                      size: 20, // Size in half-points (24px = 48 half-points)
                      font: "Calibri",
                    }),
                  ],
                  spacing: {
                    before: 50,
                    after: 100,
                  },
                  indent: {
                    left: 50, // Indent left (12px)
                    right: 50, // Indent left (12px)
                  },
                  alignment: 'left', // Center the text within the cell
                })
              ],
            })
            tableRowChild.push(refLinkType)
          } else {
            let refLinkType = new TableCell({
              children: [
                new Paragraph({
                  children: [
                    new TextRun({
                      text: imgRow.imgUrl,
                      size: 20, // Size in half-points (24px = 48 half-points)
                      font: "Calibri",
                    }),
                  ],
                  spacing: {
                    before: 50,
                    after: 100,
                  },
                  indent: {
                    left: 50, // Indent left (12px)
                    right: 50, // Indent left (12px)
                  },
                  alignment: 'left', // Center the text within the cell
                })
              ],
            })
            tableRowChild.push(refLinkType)
          }
          
          let tableRow = new TableRow({
            children: tableRowChild,
          })
          
          carouselTableRow.push(tableRow)
        }
        let carouselTable = new Table({
          width: {
            size: '100%', // Set width to 100% of the page
            type: 'pct'
          },
          rows: carouselTableRow
        });
        children.push(carouselTable)
      }
      children.push(spaceHund)
      children.push(spaceHund)
      children.push(spaceHund)
      children.push(spaceHund)
    }
  }

  const verPara = new Paragraph({
    children: [
        new TextRun({
            text: `${creatorConceptData.versionNo}, ${ContentWordGeneratorInc.formatDate(creatorConceptData.createdAt)}`,
            bold: false,
            size: 18, // Optional: Set font size (24 means 12pt)
        }),
    ],
    alignment: "left", // Align text to the left
  });

  children.push(verPara)

  // // Create a table to simulate the background color
  // const deliTableTitle = new Table({
  //   rows: [
  //     new TableRow({
  //       children: [
  //         new TableCell({
  //           children: [
  //             new Paragraph({
  //               children: [
  //                 new TextRun({
  //                   text: 'TikTok 1',
  //                   bold: true, // Bold text
  //                   size: 27, // Size in half-points (24px = 48 half-points)
  //                 }),
  //               ],
  //               spacing: {
  //                 before: 100,
  //                 after: 100,
  //               },
  //               indent: {
  //                 left: 100, // Indent left (12px)
  //                 top: 240, // Indent right (12px)
  //               },
  //               alignment: 'left', // Center the text within the cell
  //             }),
  //           ],
  //           shading: {
  //             fill: 'F4F4F4', // Light gray background color
  //           },
  //           width: {
  //             size: '100', // Width of the cell
  //             type: 'pct',
  //           },
  //           borders: {
  //             top: { style: undefined },
  //             bottom: { style: undefined },
  //             left: { style: undefined },
  //             right: { style: undefined },
  //           },
  //         }),
  //       ],
  //     }),
  //   ]
  // });

  const doc = new Document({
    sections: [
      {
        properties: {},
        children
      }
    ],
  });

  Packer.toBlob(doc).then((blob) => {
    saveAs(blob, `@${creatorConceptData.creatorHandle} ${creatorConceptData.campaignName}.docx`);
    console.log('Document created successfully');
  });
  return true
}

export const formatDate = (date) => {
  return moment(date).format('DD-MM-YYYY, HH:mm');
}

export const getTextBlocks = (text) => {
  if (text !== undefined && text !== null) {
    let textP = text.replace(/\n/g, `<p>`);
    // textP = textP.split('<p>').map(t => t.trim());
    textP = textP.split(/(<span[^>]*>.*?<\/span>|<p>|<\/p>|<[^>]+>)/).filter(Boolean);
    return textP
  }
  return []
}

export default {
  generateDocument,
  formatDate,
  getTextBlocks
}



// WEBPACK FOOTER //
// ./src/components/views/Pairing/CreatorConcept/ContentWordGenerator.js